import { SmartSendItemApiModel } from '~/lib/api/smartsend/types';
import { onlyUniqueNonBlank } from '../../../../lib/helpers/ArrayHelper';
import { Conditions } from '../../rules/Conditions';

export function getItemValuesForCondition(item: SmartSendItemApiModel, condition: string): string[] {
  switch (condition) {
    case Conditions.Item_Sku:
      return item.MarketplaceOrderLines.map((m) => m.Product?.Sku).filter(onlyUniqueNonBlank);
    case Conditions.Item_TariffCode:
      return item.MarketplaceOrderLines.map((m) => m.Product?.TariffCode).filter(onlyUniqueNonBlank);
    case Conditions.Item_MarketplaceService:
      return [item.Meta['MarketplaceService']?.Value].filter(onlyUniqueNonBlank);
    case Conditions.Item_Name:
      return [item.MarketplaceOrderLines[0].Product?.Description].filter(onlyUniqueNonBlank);
    case Conditions.Item_Source:
      return item.MarketplaceOrderLines.map((m) => m.Source.Id).filter(onlyUniqueNonBlank);
    default:
      return [];
  }
}
